import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  "xmlns:xlink": "http://www.w3.org/1999/xlink",
  fill: "none",
  version: "1.1",
  width: "8.486583709716797",
  height: "6.052704811096191",
  viewBox: "0 0 8.486583709716797 6.052704811096191"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("g", null, [
      _createElementVNode("path", {
        d: "M4.24329,4.55786C4.24329,4.55786,3.5,5.22682,3.5,5.22682C3.5,5.22682,4.24329,6.0527,4.24329,6.0527C4.24329,6.0527,4.98658,5.22682,4.98658,5.22682C4.98658,5.22682,4.24329,4.55786,4.24329,4.55786C4.24329,4.55786,4.24329,4.55786,4.24329,4.55786ZM0,1.33793C0,1.33793,3.5,5.22682,3.5,5.22682C3.5,5.22682,4.98658,3.88889,4.98658,3.88889C4.98658,3.88889,1.48659,0,1.48659,0C1.48659,0,0,1.33793,0,1.33793C0,1.33793,0,1.33793,0,1.33793ZM4.98658,5.22682C4.98658,5.22682,8.48658,1.33793,8.48658,1.33793C8.48658,1.33793,7,0,7,0C7,0,3.5,3.88889,3.5,3.88889C3.5,3.88889,4.98658,5.22682,4.98658,5.22682C4.98658,5.22682,4.98658,5.22682,4.98658,5.22682Z",
        fill: "#000000",
        "fill-opacity": "1"
      })
    ], -1)
  ])))
}
export default { render: render }